// https://www.flaticon.com/
const other: Array<number> = []
export default other
